export const leadStatusOptions = [
  { value: "PROSPECT", label: "Prospect" },
  { value: "OPEN", label: "Open" },
  { value: "WORKING", label: "Working" },
  { value: "MEETING_SET", label: "Meeting Set" },
  { value: "OPPORTUNITY", label: "Opportunity" },
  { value: "CLOSED", label: "Closed" },
  { value: "OPPORTUNITY_LOST", label: "Opportunity Lost" },
  { value: "NOT_A_TARGET", label: "Not a Target" },
  { value: "DISQUALIFIED", label: "Disqualified" },
  { value: "NURTURE", label: "Nurture" },
  { value: "INACTIVE", label: "Inactive" },
];
export const targetRoleStatusOptions = [
  { value: "INVESTOR", label: "Investor" },
  { value: "PARTNER", label: " Partner" },
  { value: "POLICY_MASTER", label: " Policy Holder" },
];
export const leadStageStatusOptions = [
  { value: "working", label: "Working" },
  { value: "qualified", label: "  Qualified" },
  { value: "disqualified", label: "  Disqualified" },
];
export const sourceOptions = [
  { value: "PARTNER", label: "Partner" },
  { value: "INSURER", label: "Insurer" },
  { value: "INTERNAL", label: "Internal" },
];
export const leadTypeOptions = [
  { value: "COLLACTION", label: "Collaction" },
  { value: "ASSIGNMENT", label: "Assignment" },
  { value: "PREMIUM_FINANCE", label: "Premium Finance" },
  { value: "LOAN", label: "Loan Against Policy" },
  // { value: "USER", label: "User" },
];
export const campaignTypeStatusOptions = [
  { value: "GENERAL", label: "General" },
  { value: "DEDICATED", label: "Dedicated" },
];

export const searchOptions = [
  { value: "filter['name']", label: "Name" },
  { value: "filter['email']", label: "Email" },
  { value: "filter['phoneNumber']", label: "Phone Number" },
  { value: "filter['policyNumber']", label: "Policy Number" },
];
